import { render } from "./MiscHeaderComponent.vue?vue&type=template&id=27b2b878&scoped=true"
import script from "./MiscHeaderComponent.vue?vue&type=script&lang=js"
export * from "./MiscHeaderComponent.vue?vue&type=script&lang=js"

import "./MiscHeaderComponent.vue?vue&type=style&index=0&id=27b2b878&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b2b878"]])

export default __exports__